import { api } from "./api";

/**
 * Chat de la sala.
 *
 * El canal público lo comparte toda la sala; los privados son hilos
 * independientes entre la modelo y cada cliente, identificados siempre por el
 * id del cliente (`thread`). La modelo puede pedir cualquiera de sus hilos; un
 * cliente solo tiene el suyo y el backend lo resuelve solo, así que desde su
 * lado `thread` puede omitirse.
 */
export const chatService = {
    sendMessage: ({ message, room_id, type = 'public', thread = null }) =>
        api.post('/chat/send', {
            message,
            room_id,
            type,
            ...(thread ? { to_user_id: thread } : {}),
        }),

    /** Devuelve { messages, has_more, currentPage } en orden cronológico. */
    getHistory: (room_id, type = 'public', thread = null) =>
        api.get(`/chat/history/${room_id}`, {
            params: { type, ...(thread ? { with: thread } : {}) },
        }),

    /** Bandeja de la modelo: un resumen por cliente que le ha escrito. */
    getConversations: (room_id) => api.get(`/chat/rooms/${room_id}/conversations`),

    markAsRead: (room_id, thread = null) =>
        api.post(`/chat/rooms/${room_id}/read`, thread ? { with: thread } : {}),
};
